import { useEffect } from "react";
import { useFieldActions } from "../../../../contexts/field-actions-context.js";
import { DataStatus } from "../../appointment-state.js";
import { useAppointmentContext } from "../../context/appointment-context.js";
import { isSameDay, getDateRange } from "../../utils/format-timezone.js";
const useSlotSelectedFromTP = ({
  setIsReloadingSlots
}) => {
  const { appointmentFieldProps, appointmentState, setAppointmentState } = useAppointmentContext();
  const { value: selectedSlot } = appointmentFieldProps;
  const { actions } = useFieldActions();
  useEffect(() => {
    const slotSelectedByOutSource = async () => {
      if (selectedSlot?.startDate && appointmentState?.selectedDate && appointmentState?.dataStatus === DataStatus.DONE) {
        const sameDate = isSameDay(
          new Date(selectedSlot.startDate),
          appointmentState?.selectedDate
        );
        if (!sameDate) {
          setIsReloadingSlots(true);
          const selectedDate = new Date(selectedSlot.startDate);
          const { fromDate, toDate } = getDateRange(selectedDate, 8);
          const [availabilityDatesToUpdate, availabilitySlotsToUpdate] = await Promise.all([
            actions?.getAvailabilityDates?.({
              serviceId: appointmentFieldProps?.initialData.service.id,
              timeZone: appointmentState?.timezone || "",
              fromDate,
              toDate
            }),
            actions?.getAvailabilitySlots?.({
              serviceId: appointmentFieldProps?.initialData.service.id,
              timeZone: appointmentState?.timezone || "",
              selectedDate
            })
          ]);
          setAppointmentState({
            availabilityDates: availabilityDatesToUpdate,
            selectedDate,
            availabilitySlots: availabilitySlotsToUpdate
          });
          setIsReloadingSlots(false);
        }
      }
    };
    slotSelectedByOutSource();
  }, [selectedSlot, appointmentState?.dataStatus]);
};
export {
  useSlotSelectedFromTP
};
//# sourceMappingURL=index.js.map
